__turbopack_context__.v({
  "button": "AKAgCa_button",
  "internal-icon": "AKAgCa_internal-icon",
});
